import React from "react";
import CNRProcessingStatus from "components/app/tool/cnrProcessingStatus";

const ScreenCNRProcessingStatus = () => {
	return <CNRProcessingStatus />;
};

export default ScreenCNRProcessingStatus;


